module.exports = __webpack_public_path__ + "img/14_26@2x.6ed48b15.png";